<template>
    <div class="mx-auto w-full max-w-[1168px] pb-40 px-8 pt-6">
        <template v-if="state==='loaded'">
            <ui-header :title="`Early Warning Notice ${earlyWarningNotice.referenceNumber}`"
                       :subtitle="'ID #'+this.earlyWarningNotice.id">
                <template #actions>
                    <ui-dropdown placement="bottom-end" menu-class="p-3 w-72">
                        <template #default="{ toggle }">
                            <ui-button-new @click="toggle" primary>
                                Actions
                                <i class="flex-shrink-0 ml-2 fa fa-chevron-down"></i>
                            </ui-button-new>
                        </template>

                        <template #menu="{ close }">
                            <ui-dropdown-item @click.prevent="openDeleteModal();" danger icon="fa fa-trash">Delete
                            </ui-dropdown-item>
                        </template>
                    </ui-dropdown>
                </template>
            </ui-header>

            <!-- General Info -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
                <div>
                    <ui-date-picker label="Date" name="dateTime" v-model="earlyWarningNotice.date"
                                    class="xl:col-span-6"
                                    placeholder="What is the date?"
                                    :error="dateTimeError"
                                    :with-time="false"
                                    @input="dateTimeError='';save();"></ui-date-picker>
                </div>
                <div>
                    <label class="block text-sm font-medium text-gray-700">Raised By</label>
                    <input type="text" placeholder="e.g. Site Manager" v-model="earlyWarningNotice.raisedBy"
                           @input="save"
                           class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm">
                </div>
                <div>
                    <label class="block text-sm font-medium text-gray-700">Discipline / Trade</label>
                    <input type="text" placeholder="e.g. Roofing" v-model="earlyWarningNotice.discipline"
                           @input="save"
                           class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm">
                </div>
            </div>

            <!-- Description -->
            <div class="mt-4">
                <ui-textarea autoresize label="Description of Issue" name="s"
                             v-model="earlyWarningNotice.issueDescription"
                             placeholder="Describe the issue, risk, or change"
                             @input="save"
                             class=""></ui-textarea>
            </div>

            <!-- Impact on Programme -->
            <div class="mt-4">
                <label class="block text-sm font-medium text-gray-700 mb-1">Will this impact the programme?</label>
                <div class="flex items-center space-x-6 mt-1">
                    <label class="inline-flex items-center text-sm text-gray-700">
                        <input type="radio" name="impactProgramme" :value="true"
                               v-model="earlyWarningNotice.willImpactProgramme"
                               @input="save"
                               class="text-blue-600 border-gray-300 focus:ring-blue-500">
                        <span class="ml-2">Yes</span>
                    </label>
                    <label class="inline-flex items-center text-sm text-gray-700">
                        <input type="radio" name="impactProgramme" :value="false"
                               v-model="earlyWarningNotice.willImpactProgramme"
                               @input="save"
                               class="text-blue-600 border-gray-300 focus:ring-blue-500">
                        <span class="ml-2">No</span>
                    </label>
                </div>
            </div>

            <!-- Action-->
            <div class="mt-4">
                <ui-textarea autoresize label="Proposed Action" name="s"
                             v-model="earlyWarningNotice.proposedAction"
                             laceholder="Suggested action to mitigate the issue"
                             @input="save"
                             class=""></ui-textarea>
            </div>

            <div class="w-full mb-2 flex mt-6">
                <div class="flex-grow"></div>
                <div class="flex-shrink mb-1">
                    <ui-button-new small
                                   class="items-baseline"
                                   icon="fas fa-upload"
                                   @click="showFS">Early Warning Notice Supporting Documents
                    </ui-button-new>
                </div>
            </div>

        </template>
    </div>
</template>

<script>
import UiContainer from "../../ui/UiContainer.vue";
import UiDatePicker from "../../ui/UiDatePicker.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiHeader from "../../ui/UiHeader.vue";
import UiInput from "../../ui/UiInput.vue";
import UiToggle from "../../ui/UiToggle.vue";
import moment from "moment";
import {debounce} from "lodash";
import {EarlyWarningNotice} from "@models";
import UiSelect from "../../ui/UiSelect.vue";
import {uuid} from "../../../utils";

export default {
    components: {
        UiSelect,
        UiToggle, UiInput, UiHeader, UiDataGridItem, UiDatePicker, UiButtonNew, UiContainer
    },
    props: {
        item: Object,
        packageReference: null,
        fsModal: Object,
        removeItem: Function,
    },
    data() {
        return {
            earlyWarningNotice: {},
            busy: false,
            dateTimeError: '',
            moment,
            state: 'loading',
            debouncedUpdate: debounce(this.update, 300),
        }
    },
    computed: {},
    methods: {
        async save() {
            this.dateTimeError = '';
            if (!this.earlyWarningNotice.date || this.earlyWarningNotice.date === "Invalid date") {
                this.dateTimeError = 'Please select a date of issue for this Early Warning Notice'
            } else {
                this.earlyWarningNotice.formatted_date = moment(this.earlyWarningNotice.date).format('DD/MM/YYYY');
                Object.assign(this.item, this.earlyWarningNotice);
                this.debouncedUpdate();
            }
        },
        addItem() {
            this.earlyWarningNotice.breakdown.push({
                index: uuid(),
                type: 'Labour',
                description: '',
                quantity: 8
            })
            this.save()
        },
        async update() {
            this.busy = true;
            this.earlyWarningNotice.date = moment(this.earlyWarningNotice.date).format("YYYY-MM-DD");
            await this.earlyWarningNotice.update();
            this.busy = false;
        },
        showFS() {
            this.fsModal.openModal(this.earlyWarningNotice.filesystemId);
        },
        minDate() {
            return null;
        },
        openDeleteModal() {
            const title = 'Are you sure you want to remove Early Warning Notice ' + this.item.referenceNumber + '?'
            const description = 'You are removing Early Warning Notice #' + this.item.id + '. Are you sure you want to do this?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.earlyWarningNotice.delete()
                this.removeItem(this.item)
            });
        },
    },
    async mounted() {
        this.earlyWarningNotice = await EarlyWarningNotice.find(this.packageReference, this.item.id);
        this.state = 'loaded'
    },
}
</script>
